import { INewViewHistory, IViewHistory, ViewHistory } from '../_interfaces/ViewHistory';
import { CrudService } from './CrudService';

export class ViewHistoryService extends CrudService<IViewHistory, INewViewHistory, Partial<INewViewHistory>> {
    protected basePath = 'viewHistory';

    protected assembleInstances(response: Array<IViewHistory>): Array<ViewHistory> {
        const out: Array<ViewHistory> = [];

        response.forEach((record) => {
            const valid: ViewHistory = this.assembleSingleInstance(record);
            out.push(valid);
        });

        return out;
    }

    protected assembleSingleInstance(response: IViewHistory): ViewHistory {
        return new ViewHistory(response);
    }
}



// WEBPACK FOOTER //
// ./src/_services/ViewHistoryService.ts